import React, { useState, useEffect } from 'react';
import { MdStore } from "react-icons/md";
import { FaSquare, FaPiggyBank, FaUserClock, FaCoins } from "react-icons/fa";
import {  RiSwordFill  } from "react-icons/ri";
import { IoPersonAdd } from "react-icons/io5";
import './Transparency.css'


import { AiFillSecurityScan, AiFillSafetyCertificate  } from "react-icons/ai";
import { BsShieldFillExclamation, BsTransparency } from "react-icons/bs";
import { GiSwordsEmblem, GiPayMoney, GiCash } from "react-icons/gi";
import { SiCyberdefenders } from "react-icons/si";
import { LuCalendarClock } from "react-icons/lu";
import { FaMoneyBillWave } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { MdOutlineCenterFocusWeak } from "react-icons/md";
import { PiStrategyBold, PiIdentificationCardFill } from "react-icons/pi";
import { FaUniversalAccess } from "react-icons/fa6";
import { ImConfused2 } from "react-icons/im";
import { HiMiniUserGroup } from "react-icons/hi2";
import { GrCompliance } from "react-icons/gr";






const Transparency = () => {
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isDashModalOpen, setIsDashModalOpen] = useState(false);


    const goals = [
        {
            goal: 'System intelligibility for decision making',
            PreGoal:'Goal T1:',
            description: 'AI systems that inform decision making by or about people are designed to support stakeholder needs for intelligibility of system behaviour.',
            appliesTo: 'All AI systems when the intended use of the generated outputs is to inform decision making by or about people.',
            requirements: [
                {
                    id: 'T1.1',
                    text: 'Identify:',
                    subRequirements: [
                        "stakeholders who will use the outputs of the system to make decisions, and",
                        "stakeholders who are subject to decisions informed by the system. ",
                        "Document these stakeholders using the Impact Assessment template. ",
                    ],
                    tags: ['Impact Assessment']
                },
                {
                    id: 'T1.2',
                    text: 'Design the system, including, when possible, the system UX, features, reporting functions, and educational materials, so that stakeholders identified in requirement T1.1 can: ',
                    subRequirements: [
                        "understand the system’s intended uses,",
                        "interpret relevant system behaviour effectively (i.e., in a way that supports informed decision making), and",
                        'remain aware of the possible tendency of over-relying on outputs produced by the system ("automation bias").',
                    ],
                    text2: 'For the two categories of stakeholders identified in requirement T1.1, document:',
                    subRequirements2: [
                        "how the system design will support their understanding of the system’s intended uses, and",
                        "how the system aids their ability to interpret relevant system responses, and",
                        "how the system design discourages automation bias.",
                    ],
                    tags: ['Impact Assessment']
                },
                {
                    id: 'T1.3',
                    text: 'Define and document the method to be used to evaluate whether each stakeholder who will make decisions or be subject to decisions based on the behaviour of the system can interpret the relevant system responses reasonably well. Include the metrics or rubrics that will be used in the evaluations. ',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'T1.4',
                    text: 'Define and document a Responsible Release Plan, to include Responsible Release Criteria to achieve this Goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'T1.5',
                    text: 'Conduct evaluations defined by requirement T1.3. Document the pre-release results of the evaluations. Determine and document how often ongoing evaluation should be conducted to continue supporting this Goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'T1.6',
                    text: 'If there are Responsible Release Criteria for metrics or rubrics that that have not been met, consult with the reviewers named in the Impact Assessment, and in the case of Sensitive Uses, with the responsible person(s), to develop a plan detailing how the gap will be managed until it can be closed. Document that plan.',
                    tags: null
                },
            ]
        },
        {
            goal: 'Communication to stakeholders',
            PreGoal:'Goal T2:',
            description: 'Provide information about the capabilities and limitations of AI systems to support stakeholders in making informed choices about those systems.',
            appliesTo: 'All AI systems.',
            requirements: [
                {
                    id: 'T2.1',
                    text: 'Identify:',
                    subRequirements: [
                        "stakeholders who make decisions about whether to employ a system for particular tasks, and",
                        "stakeholders who develop or deploy systems that integrate with this system.",
                    ],
                    text2: 'Document these stakeholders in the Impact Assessment template.',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'T2.2',
                    text: 'Publish documentation for the system so that stakeholders defined in T2.1 can understand the system.',
                    text3:'Include:',
                    subRequirements: [
                        "capabilities,",
                        "intended uses,",
                        "uses that require extra care or guidance,",
                        "operational factors and settings that allow for effective and responsible system use,",
                        "limitations, including uses for which the system was not designed or evaluated, and",
                        "evidence of system accuracy and performance as well as a description of the extent to which these results are generalizable across use cases that were not part of the evaluation.",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, a Transparency Note is required.',
                    tags: ['Transparency Note.']
                },
                {
                    id: 'T2.3',
                    text: 'Review and update documentation annually or when any of the following events occur:',
                    subRequirements: [
                        "new uses are added,",	
                        "functionality changes,",
                        "the product moves to a new release stage,",
                        "new information about reliable and safe performance becomes known as defined by requirement RS3.3, or",
                        "new information about system accuracy and performance becomes available.",
                    ],
                    text2: 'When the system is a platform service made available to external customers or partners, include this information in the required Transparency Note.',
                    tags: ['Transparency Note.']
                },
            ]
        },
        {
            goal: 'Disclosure of AI interaction',
            PreGoal:'Goal T3:',
            description: 'AI systems are designed to inform people that they are interacting with an AI system or are using a system that generates or manipulates image, audio, or video content that could falsely appear to be authentic.',
            appliesTo: 'AI systems that impersonate interactions with humans, unless it is obvious from the circumstances or context of use that an AI system is in use. AI systems that generate or manipulate image, audio, or video content that could falsely appear to be authentic.',
            requirements: [
                {
                    id: 'T3.1',
                    text: 'Identify stakeholders who will use or be exposed to the system, in accordance with the Impact Assessment requirements. Document these stakeholders using the Impact Assessment template. ',
                    tags: ['Impact Assessment']
                },
                {
                    id: 'T3.2',
                    text: 'Identify stakeholders who will use or be exposed to the system, in accordance with the Impact Assessment requirements. Document these stakeholders using the Impact Assessment template.',
                    tags: ['Impact Assessment.']
                },
                {
                    id: 'T3.3',
                    text: 'Design the system, including system UX, features, reporting functions, educational materials, and outputs so that stakeholders identified in T3.1 will be informed of the type of AI system they are interacting with or exposed to. Ensure that any image, audio, or video outputs that are intended to be used outside the system are labelled as being produced by AI.',
                    tags: null
                },
                {
                    id: 'T3.4',
                    text: 'Define and document the method to be used to evaluate whether each stakeholder identified in T3.1 is informed of the type of AI system they are interacting with or exposed to. ',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'T3.5',
                    text: 'Define and document Responsible Release Criteria to achieve this Goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
                {
                    id: 'T3.6',
                    text: 'Conduct evaluations defined by requirement T3.3. Document the pre-release results of the evaluations. Determine and document how often ongoing evaluation should be conducted to continue supporting this goal.',
                    tags: ['Ongoing Evaluation Checkpoint.']
                },
            ]
        },
    ];
 

  // Modal component
  const DashModal = ({ isOpen, onClose, selectedGroup }) => {
    if (!isOpen || !selectedGroup) return null;
  
    // Fetch the specific goal data based on `selectedGroup`
    const goalData = goals.find(goal => goal.goal === selectedGroup);
  
    if (!goalData) return null;
  
    return (
      <div className="dashModal">
        <div className="dashModalContent">
          <div className="dashModalBox">
            {/* Title Section */}
            <h2 className="goal-title">
              <span className="goal-prefix">{goalData.PreGoal}</span> <span className="Trans-goal-name">{goalData.goal}</span>
            </h2>
            <p className="applies-to">{goalData.description}</p>
            <p className="applies-to"><i>Applies to:</i> {goalData.appliesTo}</p>          
            {/* Requirements Table */}
            <div className="assessmentContainerBox">
              <table className="assessment-table">
                <thead>
                  <tr>
                    <th className="Trans-requirements-header">Requirements</th>
                  </tr>
                </thead>
                <tbody>
                  {goalData.requirements.map((requirement, index) => (
                    <tr key={index} className="requirement-row">
                      <td className="requirement-text">
                        <strong>{requirement.id}</strong> {requirement.text}
                        <br/>{requirement.text3}
                        {requirement.subRequirements && (
                            <ul className="sub-requirements-list">
                            {requirement.subRequirements.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        {requirement.text2}
                        {requirement.subRequirements2 && (
                            <ul className="sub-requirements-list">
                            {requirement.subRequirements2.map((subRequirement, subIndex) => (
                                <li key={subIndex} className="sub-requirement-item">
                                {subRequirement}
                                </li>
                            ))}
                            </ul>
                        )}
                        {requirement.tags && requirement.tags.length > 0 && (
                            <p className="tags">
                            <strong>Tags:</strong> {requirement.tags.join(', ')}
                            </p>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
  
            {/* Close Button */}
            <button className="Trans-closeButton" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  };
  


  // Handle modal opening
  const openModal = (group) => {
    console.log(`Opening modal for: ${group}`);
    setSelectedGroup(group);
    setIsDashModalOpen(true);
  };

  const closeModal = () => {
    setIsDashModalOpen(false);
    setSelectedGroup(null);
  };

  


  return (
    <div style={{backgroundColor: 'rgb(240, 242, 245)', height: '100vh'}}>
      <div className='dashcontent'>
        <div>
          <h2>Transparency Goals</h2>
        </div>
        <div className="Trans-container">
          <div className="stats-box" onClick={() => openModal('System intelligibility for decision making')}>
            <div className="icon-box black">
              <PiStrategyBold />
            </div>
            <div className="Trans-content-box">
              <br></br>
              <br></br>
              <h4>Goal T1:</h4>
              <h3>System intelligibility for decision making</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        
          <div className="stats-box" onClick={() => openModal('Communication to stakeholders')}>
            <div className="icon-box blue">
              <FaUniversalAccess />
            </div>
            <div className="Trans-content-box">
              <br></br>
              <br></br>
              <h4>Goal T2:</h4>
              <h3>Communication to stakeholders</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>

          {/* Identifiability and Linkability */}
          <div className="stats-box" onClick={() => openModal('Disclosure of AI interaction')}>
            <div className="icon-box green">
              <PiIdentificationCardFill />
            </div>
            <div className="Trans-content-box">
              <br></br>
              <br></br>
              <h4>Goal T3:</h4>
              <h3>Disclosure of AI interaction</h3>
              <hr className="hrLine" />
              <p className="change-text">Just Updated</p>
            </div>
          </div>
        </div>
        {/* Modal for displaying the questions with recommendations */}
        <DashModal isOpen={isDashModalOpen} onClose={closeModal} selectedGroup={selectedGroup} />
      </div>
    </div>
  );
};

    

export default Transparency;